import { ATSelectionTile } from 'components/common/beacon/beaconRegistration';
import React from 'react';
import { IInternalAccount } from 'src/api/internal/internalApi.types';
import { getCurrentDate } from 'src/utils/dateUtils';
import { formatCurrency } from 'utils/numberUtils';
import AccountDetails from './AccountDetails';

const AccountList = ({
  className,
  accounts,
  title,
  selectedAccountId,
  handleSelectAccountType,
  selectedInternalAccount,
}: {
  className?: string;
  accounts: IInternalAccount[];
  title: string;
  selectedAccountId: number;
  handleSelectAccountType: (type: string, id: number, noAccounts: boolean) => void;
  selectedInternalAccount: any;
}) => (
  <div className={className}>
    <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:12-col b-lg:12-col">
      <label className="b-typography-sans-serif--headline--100 b-font-weight-bold">
        {title}
      </label>
    </div>
    <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:12-col b-lg:12-col">
      <label className="b-typography-sans-serif--body--100 b-font-weight-light">
        Balances as of {getCurrentDate()}
      </label>
    </div>
    {accounts.map((account: any) => (
      <div
        data-testid="accounts-container"
        className="accounts-container"
        key={account.agreementId}
      >
        <div className="b-grid account-title">
          <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:6-col b-lg:6-col">
            <ATSelectionTile
              className={
                !account.isTransferEligible
                  ? 'disabled beacon-on-light b-color-background--0'
                  : ''
              }
            >
              <label
                className="selection-label"
                slot="label"
                htmlFor={'account_' + account.agreementId}
              >
                {`${account.agreementTypeValue?.enumerationName ?? ''} - ${formatCurrency(
                  account.availableEquity,
                  'USD',
                )}`}
              </label>
              <input
                className={
                  !account.isTransferEligible
                    ? 'beacon-on-light b-color-background--0'
                    : ''
                }
                type="radio"
                id={'account_' + account.agreementId}
                aria-disabled={!account.isTransferEligible}
                disabled={!account.isTransferEligible}
                name="selection"
                checked={
                  account.agreementId === selectedAccountId &&
                  !selectedInternalAccount?.noAccounts
                }
                onChange={() =>
                  handleSelectAccountType(
                    account.agreementTypeValue?.enumerationName,
                    account.agreementId,
                    false,
                  )
                }
              />
            </ATSelectionTile>
          </div>
        </div>
        {account.agreementId === selectedAccountId && (
          <AccountDetails account={account} />
        )}
      </div>
    ))}
  </div>
);

export default AccountList;
